import { EMPTY_MODULE_API_INFO } from "@client/content/lib/consts";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { globals } from "@client/globals";
import { getMultiselectValue } from "@client/lib/settings";
import { TargetSelector, combinedSettingsSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import { connect } from "react-redux";
import { eventOptionItemsSelector } from "../../selectors";
import { type Checkout } from "../../types";
import Component, { type ActionProps, type MapProps } from "./component";

type Props = RootContainerProps & {
  eventDateLocationId: string | null;
  eventId: string | null;
  onChange: (name: keyof Checkout.View.Event, value: string) => void;
};
const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();

  const settingSelector = combinedSettingsSelector(TargetSelector.Entity, [
    "displayEvents",
    "eventsMode",
    { name: "events", converter: getMultiselectValue, prop: "events" },
    "eventRequired"
  ]);

  return (state: AppState, props: Props): MapProps => {
    const settings = settingSelector(state, props);

    if ((globals.siteInfo.brandKey !== "Expomarket" || !settings.displayEvents) && !state.portal.eventId) {
      return {
        ...props,
        apiInfo: EMPTY_MODULE_API_INFO,
        eventDateLocationId: null,
        eventId: null,
        eventOptions: [],
        id: "",
        isVisible: false,
        settings: {
          displayEvents: false,
          eventRequired: false,
          events: undefined,
          eventsMode: "all"
        },
        shouldShowEvents: false
      };
    }

    return {
      ...props,
      apiInfo: apiInfoSelector(state, props),
      eventOptions: eventOptionItemsSelector(state),
      isVisible: true,
      settings,
      shouldShowEvents: !state.portal.eventId
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  onChange: props.onChange
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
